// src/components/Header.js (Updated with Logo Image)

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css'; 

// --- IMPORT THE LOGO IMAGE ---
// Assuming logo.svg is in src/assets/logo/
import AppLogo from '../assets/logo/logo.png'; 
// ----------------------------


const Header = () => {
  const location = useLocation(); 

  // Define the main navigation links
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Explore', path: '/explore' },
    { name: 'Resources', path: '/resources' },
    { name: 'How It Works', path: '/how-it-works' },
  ];

  return (
    <header className="header-container">
      {/* 1. Logo / Site Name: Now uses an Image */}
      <div className="header-logo">
        <Link to="/">
          {/* Replaced <span>BP</span> with the <img> tag */}
          <img src={AppLogo} alt="Blueprint Platform Logo" className="app-logo-image" />
        </Link>
      </div>

      {/* 2. Primary Navigation Links (Center) */}
      <nav className="header-nav">
        <ul>
          {navLinks.map((link) => (
            <li key={link.name}>
              <Link 
                to={link.path}
                className={location.pathname === link.path ? 'nav-link active' : 'nav-link'}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* 3. Right-Aligned CTA / Auth (Login and Sign Up) */}
      <div className="header-actions">
        {/* Auth Buttons */}
        <Link to="/login" className="nav-link auth-link">
          Login
        </Link>
        <Link to="/signup" className="btn-secondary signup-button">
          Sign Up
        </Link>
      </div>
    </header>
  );
};

export default Header;